import { RetrieveProductTemplateAlgolia } from '@ortros/stoux-lib'

import { SearchResult } from 'stoux-shared-types/services/search'
import { HttpResponse } from 'nexus-res'

import searchClient from '@/core/algolia'
import axios from '@/core/axios'

import { GetSearchResultsDto } from '../dtos/get-search-results.dto'
import { ProductTemplate } from 'stoux-shared-types/models/product-template'

export class SearchRepository {
    public async getSearchResultByUrl(
        dto: GetSearchResultsDto,
    ): Promise<SearchResult> {
        const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/search`)

        if (dto.query) {
            url.searchParams.set('query', dto.query)
        }
        if (dto.category) {
            url.searchParams.set('category', encodeURIComponent(dto.category))
        }

        if (dto.brand) {
            url.searchParams.set('brand', dto.brand)
        }

        if (dto.sortBy) {
            url.searchParams.set('sortBy', dto.sortBy)
        }

        if (dto.minPrice) {
            url.searchParams.set('minPrice', dto.minPrice.toString())
        }

        if (dto.maxPrice) {
            url.searchParams.set('maxPrice', dto.maxPrice.toString())
        }

        if (dto.storeId) {
            url.searchParams.set('storeId', dto.storeId.toString())
        }

        if (dto.showOutOfStock) {
            url.searchParams.set(
                'showOutOfStock',
                dto.showOutOfStock.toString(),
            )
            url.searchParams.delete('minPrice')
            url.searchParams.delete('maxPrice')
        }

        if (dto.page) {
            url.searchParams.set('page', dto.page.toString())
        }

        if (dto.itemsPerPage) {
            url.searchParams.set('itemsPerPage', dto.itemsPerPage.toString())
        }

        if (dto.condition) {
            url.searchParams.set('condition', dto.condition.toString())
        }

        const { data } = await axios.post<HttpResponse<SearchResult>>(
            url.toString(),
        )
        return data.metadata!
    }

    public async getSearchResultsAlgolia(
        query: string,
    ): Promise<ProductTemplate[]> {
        const results =
            await searchClient.search<RetrieveProductTemplateAlgolia>([
                {
                    indexName: 'templates',
                    query,
                    params: {
                        hitsPerPage: 10,
                    },
                },
            ])

        const hits: ProductTemplate[] = (results.results[0] as any).hits
        return hits
    }
}
